import React, { memo } from "react";
import {
  Marker,
  Polygon
} from "@react-google-maps/api";

const SearchOnMapSection = ({
  markerOnMap,
  geohashOnMap
}) => {

  return (
    <>
      {markerOnMap && <Marker position={markerOnMap} />}
      {geohashOnMap &&
        <Polygon
          path={geohashOnMap}
          options={{
            fillColor: "white",
            fillOpacity: 0,
            strokeColor: "grey",
            strokeOpacity: 1,
            strokeWeight: 1,
            clickable: false,
            draggable: false,
            editable: false,
            geodesic: false,
            zIndex: 1,
          }}
        />}
    </>
  )
};

export default memo(SearchOnMapSection);